import React from 'react';
import { Badge, type BadgeProps } from '@good/ui/core';
import CommonUtils from 'utilities/common-utils';

interface WorkerShiftStatusBadgeProps extends BadgeProps {
  status: string;
}

export const WorkerShiftStatusBadge = ({ status, ...props }: WorkerShiftStatusBadgeProps) => {
  const StatusColors: Record<string, { color: string; variant: 'filled' | 'outline' }> = {
    UNASSIGNED: { color: 'orange', variant: 'filled' },
    PENDING: { color: 'gray', variant: 'filled' },
    CONFIRMED: { color: 'blue', variant: 'filled' },
    CHECKED_IN: { color: 'yellow.9', variant: 'filled' },
    CHECKED_OUT: { color: 'green', variant: 'filled' },
    APPROVED: { color: 'blue', variant: 'filled' },
    NO_SHOW: { color: 'red', variant: 'filled' },
    SENT_TO_FINANCE: { color: 'blue', variant: 'outline' },
    ON_LEAVE: { color: 'gray', variant: 'outline' },
    LEAVE_APPROVED: { color: 'blue', variant: 'outline' },
    CANCELLED: { color: 'gray', variant: 'outline' },
    CANCELLED_UNPAID: { color: 'red', variant: 'outline' },
    CANCELLED_PAID: { color: 'red', variant: 'outline' },
  };

  const color = StatusColors[status] ? StatusColors[status].color : 'blue';
  const variant = StatusColors[status] ? StatusColors[status].variant : 'filled';

  return (
    <Badge color={color} variant={variant} {...props}>
      {CommonUtils.formatShiftSlotStatusString(status)}
    </Badge>
  );
};
